import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

function debugRequested(): boolean {
  if (!import.meta.env.DEV) return false;
  const param = new URLSearchParams(location.search).get('debug');
  if (param === '0') {
    sessionStorage.removeItem('battlequip:debug');
    return false;
  }
  if (param !== null) {
    sessionStorage.setItem('battlequip:debug', '1');
    return true;
  }
  return sessionStorage.getItem('battlequip:debug') === '1';
}

if (import.meta.env.DEV && debugRequested()) {
  void import('./debug/mount').then(({ mountWithDebug }) => mountWithDebug(root));
} else {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if ('serviceWorker' in navigator) {
  void navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {});
}
